import React from "react";
import { ChevronRight } from "lucide-react";
import { cn } from "../../../../src/lib/utils";

interface CaseSidebarFooterProps {
  isSidebarOpen: boolean;
  onToggle: () => void;
}

export default function CaseSidebarFooter({
  isSidebarOpen,
  onToggle,
}: CaseSidebarFooterProps) {

  const buttonLabel = isSidebarOpen ? "Hide side panel" : "Show side panel";

  const containerStyle = {
    right: isSidebarOpen ? "8px" : "0px",
    width: isSidebarOpen ? "32px" : "auto",
  };

  const containerClasses= cn("fixed bottom-4 z-[120] transition-all duration-300 flex items-center justify-center");

  const buttonClasses = cn(
    "relative flex items-center justify-center transition-all duration-200 cursor-pointer group",
    isSidebarOpen
      ? "h-8 w-8 rounded-md border-none shadow-none hover:bg-gray-100"
      : "h-10 w-6 rounded-l-full border border-r-0 border-slate-200 bg-[#E5E7EB] pl-0.5 hover:w-10 hover:shadow-md hover:bg-[#E5E7EB]"
  );

  const tooltipClasses = cn(
    "absolute bottom-full mb-2 px-2 py-1 bg-gray-800 text-white text-[10px] rounded opacity-0 group-hover:opacity-100 whitespace-nowrap pointer-events-none transition-opacity",
    isSidebarOpen ? "right-[-8px]" : "right-0"
  );

  const iconClasses = cn(
    "text-slate-600 transition-transform duration-300",
    isSidebarOpen ? "rotate-0" : "rotate-180"
  );

  return (
    <div
      className={containerClasses}
      style={containerStyle}
    >
      <button
        onClick={onToggle}
        className={buttonClasses}
      >
        <ChevronRight
          size={17}
          strokeWidth={2} 
          className={iconClasses}
        />
        <span className={tooltipClasses}>
          {buttonLabel}
        </span>
      </button>
    </div>
  );
}